export default {
  title: 'Promoted products',
};
